var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCountIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "vuesax/linear/layer"
  }, /*#__PURE__*/React.createElement("g", {
    id: "layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M10.2996 2.31167L14.9705 4.38584C16.3163 4.97959 16.3163 5.96125 14.9705 6.555L10.2996 8.62917C9.7692 8.86667 8.89837 8.86667 8.36795 8.62917L3.69712 6.555C2.35129 5.96125 2.35129 4.97959 3.69712 4.38584L8.36795 2.31167C8.89837 2.07417 9.7692 2.07417 10.2996 2.31167Z",
    stroke: "#101513",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M2.375 8.70834C2.375 9.37334 2.87375 10.1413 3.48333 10.4104L8.85875 12.8013C9.27042 12.9833 9.7375 12.9833 10.1413 12.8013L15.5167 10.4104C16.1263 10.1413 16.625 9.37334 16.625 8.70834",
    stroke: "#101513",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M2.375 12.6667C2.375 13.4029 2.81042 14.0679 3.48333 14.3687L8.85875 16.7596C9.27042 16.9417 9.7375 16.9417 10.1413 16.7596L15.5167 14.3687C16.1896 14.0679 16.625 13.4029 16.625 12.6667",
    stroke: "#101513",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCountIcon);
export default __webpack_public_path__ + "static/media/count-icon.e89a06471ce8604988b3b132dede86cf.svg";
export { ForwardRef as ReactComponent };